import React from 'react';
import { CURRENCIES } from './CurrenciesList';

/**
 * Currency Property - Allows selecting currency type for currency field
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CurrencyProperty = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  if (field.type !== 'currency') {
    return null;
  }
  const currency = field.currency || 'USD';
  return /*#__PURE__*/_jsxs("div", {
    className: "property-section",
    children: [/*#__PURE__*/_jsx("label", {
      className: "section-label",
      children: "Currency Settings"
    }), /*#__PURE__*/_jsxs("div", {
      className: "currency-config-section",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "property-item",
        children: [/*#__PURE__*/_jsx("label", {
          className: "property-label",
          children: "Default Currency"
        }), /*#__PURE__*/_jsx("select", {
          value: currency,
          onChange: e => updateField(selectedField, {
            currency: e.target.value
          }),
          className: "property-input",
          children: CURRENCIES.map(curr => /*#__PURE__*/_jsxs("option", {
            value: curr.code,
            children: [curr.code, " - ", curr.name, " (", curr.symbol, ")"]
          }, curr.code))
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "property-item",
        children: /*#__PURE__*/_jsxs("label", {
          className: "checkbox-label",
          children: [/*#__PURE__*/_jsx("input", {
            type: "checkbox",
            checked: field.currencyEditable !== false,
            onChange: e => {
              // Explicitly set to true or false (not undefined)
              updateField(selectedField, {
                currencyEditable: e.target.checked
              });
            }
          }), "Currency selectbox editable"]
        })
      })]
    })]
  });
};